/**
 * The open/close contract the app's small popovers share (`EnergyBadgeButton`, `BadgeGlossary`):
 * an outside pointerdown or Escape closes it. Pass the element that holds both the trigger and the
 * popover as `rootRef`.
 */

import { useEffect, type RefObject } from "react";

export function useDismissablePopover(
  open: boolean,
  close: () => void,
  rootRef: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    if (!open) return;
    function onPointerDown(event: PointerEvent) {
      if (rootRef.current && !rootRef.current.contains(event.target as Node)) close();
    }
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === "Escape") close();
    }
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, close, rootRef]);
}
